import localStorageKeys from './localStorageKeys';

export const isMonthBeforeDay = () => {
  const dateNotation = localStorage.getItem(localStorageKeys.fullDateNotation);
  if (!dateNotation) return true;
  const monthAndDay = dateNotation.split(',')[0];
  return monthAndDay === 'MMM DD';
};
